import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Alert
} from '@mui/material';
import toast from 'react-hot-toast';

const REJECTION_REASONS = [
  "Rental period too short",
  "Rental period too long",
  "Price offered too low",
  "Berth not available during requested dates",
  "Vessel size incompatible with berth dimensions",
  "Owner prefers long-term rentals",
  "Weather or maintenance restrictions",
  "Owner currently using the berth",
  "Request received too late / short notice",
  "Other (non-specified reason)"
];

export const RejectionModal = ({
  open,
  onClose,
  onConfirm,
  loading
}) => {
  const [selectedReason, setSelectedReason] = useState("");
  const [customMessage, setCustomMessage] = useState("");

  const handleConfirm = () => {
    if (!selectedReason) {
      toast.error("Please select a rejection reason");
      return;
    }

    if (selectedReason === "Other (non-specified reason)" && !customMessage.trim()) {
      toast.error("Please provide a reason");
      return;
    }

    const finalMessage = selectedReason === "Other (non-specified reason)"
      ? customMessage.trim()
      : selectedReason;

    onConfirm(finalMessage);
  };

  const handleClose = () => {
    setSelectedReason("");
    setCustomMessage("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Reason for Rejecting Request
      </DialogTitle>

      <DialogContent>
        <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
          The customer will be notified of your reason for rejecting this request.
        </Alert>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="reason-select-label">Select Reason *</InputLabel>
          <Select
            labelId="reason-select-label"
            id="reason-select"
            value={selectedReason}
            label="Select Reason *"
            onChange={(e) => setSelectedReason(e.target.value)}
          >
            {REJECTION_REASONS.map((reason) => (
              <MenuItem key={reason} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedReason === "Other (non-specified reason)" && (
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Please specify the reason *"
            placeholder="Provide additional details..."
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            helperText={`${customMessage.length}/500 characters`}
            inputProps={{ maxLength: 500 }}
          />
        )}

        {selectedReason && selectedReason !== "Other (non-specified reason)" && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Selected: <strong>{selectedReason}</strong>
          </Alert>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? "Rejecting..." : "Confirm Rejection"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
